import { graphql } from 'app/generated/gql'

export const FORM_TEMPLATES_QUERY = graphql(`
  query PaperworkFormTemplates($archived: Boolean, $formId: ID, $status: String, $pagination: PaginationInput) {
    formTemplates(archived: $archived, formId: $formId, status: $status, pagination: $pagination) {
      hits {
        version
        createdDate
        updatedDate
        id
        orgId
        workspaceId
        formId
        name
        description
        category
        formVersion
        status
        publishedDate
        archived
        questionsJson
      }
      total
      page
    }
  }
`)

export const FORM_TEMPLATE_QUERY = graphql(`
  query PaperworkFormTemplate($id: ID!) {
    formTemplate(id: $id) {
      version
      createdDate
      updatedDate
      id
      orgId
      workspaceId
      formId
      name
      description
      category
      formVersion
      status
      publishedDate
      archived
      questionsJson
    }
  }
`)

export const CREATE_FORM_TEMPLATE_MUTATION = graphql(`
  mutation PaperworkCreateFormTemplate($input: CreateFormTemplateInput!) {
    createFormTemplate(input: $input) {
      version
      createdDate
      updatedDate
      id
      orgId
      workspaceId
      formId
      name
      description
      category
      formVersion
      status
      publishedDate
      archived
      questionsJson
    }
  }
`)

export const UPDATE_FORM_TEMPLATE_MUTATION = graphql(`
  mutation PaperworkUpdateFormTemplate($id: ID!, $input: UpdateFormTemplateInput!) {
    updateFormTemplate(id: $id, input: $input) {
      version
      createdDate
      updatedDate
      id
      orgId
      workspaceId
      formId
      name
      description
      category
      formVersion
      status
      publishedDate
      archived
      questionsJson
    }
  }
`)

export const PUBLISH_FORM_TEMPLATE_MUTATION = graphql(`
  mutation PaperworkPublishFormTemplate($id: ID!) {
    publishFormTemplate(id: $id) {
      version
      createdDate
      updatedDate
      id
      orgId
      workspaceId
      formId
      name
      description
      category
      formVersion
      status
      publishedDate
      archived
      questionsJson
    }
  }
`)

export const DRAFT_NEXT_FORM_TEMPLATE_VERSION_MUTATION = graphql(`
  mutation PaperworkDraftNextFormTemplateVersion($id: ID!) {
    draftNextFormTemplateVersion(id: $id) {
      version
      createdDate
      updatedDate
      id
      orgId
      workspaceId
      formId
      name
      description
      category
      formVersion
      status
      publishedDate
      archived
      questionsJson
    }
  }
`)

export const DELETE_FORM_TEMPLATE_MUTATION = graphql(`
  mutation PaperworkDeleteFormTemplate($id: ID!) {
    deleteFormTemplate(id: $id)
  }
`)

export const PAPERWORK_TEMPLATES_QUERY = graphql(`
  query PaperworkTemplates($archived: Boolean, $pagination: PaginationInput) {
    paperworkTemplates(archived: $archived, pagination: $pagination) {
      hits {
        version
        createdDate
        updatedDate
        id
        orgId
        workspaceId
        name
        description
        archived
        formsJson
        brandingJson
        appearanceJson
        welcomeJson
        completionJson
      }
      total
      page
    }
  }
`)

export const PAPERWORK_TEMPLATE_QUERY = graphql(`
  query PaperworkTemplate($id: ID!) {
    paperworkTemplate(id: $id) {
      version
      createdDate
      updatedDate
      id
      orgId
      workspaceId
      name
      description
      archived
      formsJson
      brandingJson
      appearanceJson
      welcomeJson
      completionJson
    }
  }
`)

export const CREATE_PAPERWORK_TEMPLATE_MUTATION = graphql(`
  mutation PaperworkCreateTemplate($input: CreatePaperworkTemplateInput!) {
    createPaperworkTemplate(input: $input) {
      version
      createdDate
      updatedDate
      id
      orgId
      workspaceId
      name
      description
      archived
      formsJson
      brandingJson
      appearanceJson
      welcomeJson
      completionJson
    }
  }
`)

export const UPDATE_PAPERWORK_TEMPLATE_MUTATION = graphql(`
  mutation PaperworkUpdateTemplate($id: ID!, $input: UpdatePaperworkTemplateInput!) {
    updatePaperworkTemplate(id: $id, input: $input) {
      version
      createdDate
      updatedDate
      id
      orgId
      workspaceId
      name
      description
      archived
      formsJson
      brandingJson
      appearanceJson
      welcomeJson
      completionJson
    }
  }
`)

export const DELETE_PAPERWORK_TEMPLATE_MUTATION = graphql(`
  mutation PaperworkDeleteTemplate($id: ID!) {
    deletePaperworkTemplate(id: $id)
  }
`)

export const PAPERWORK_LOCATIONS_QUERY = graphql(`
  query PaperworkBrandingLocations($search: String, $pagination: PaginationInput) {
    locations(search: $search, pagination: $pagination) {
      hits {
        id
        name
        businessPhone
      }
      total
      page
    }
  }
`)

export const CONTACT_PAPERWORKS_QUERY = graphql(`
  query ContactPaperworks($search: String, $pagination: PaginationInput, $sort: SortInput) {
    paperworks(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        version
        createdDate
        updatedDate
        id
        orgId
        workspaceId
        locationId
        paperworkTemplateId
        patientId
        token
        expiresDate
        status
        openedDate
        completedDate
        cancelledDate
        snapshotJson
        submissionsJson
        processingStatus
        processingCompletedDate
        chartWritesJson
        link
        fullyComplete
        formStatuses {
          formId
          name
          completed
          submittedDate
        }
        chartWriteStatuses {
          formId
          status
          externalId
          errorMessage
          completedDate
        }
      }
      total
      page
    }
  }
`)

export const RESEND_PAPERWORK_MUTATION = graphql(`
  mutation ResendPaperwork($id: ID!) {
    resendPaperwork(id: $id) {
      id
      status
      expiresDate
      openedDate
      cancelledDate
      link
      token
    }
  }
`)

export const CANCEL_PAPERWORK_MUTATION = graphql(`
  mutation CancelPaperwork($id: ID!) {
    cancelPaperwork(id: $id) {
      id
      status
      cancelledDate
    }
  }
`)

export const PAPERWORK_PATIENTS_QUERY = graphql(`
  query PaperworkPatients($search: String, $pagination: PaginationInput) {
    patients(search: $search, pagination: $pagination) {
      hits {
        id
        pmsPatientId
        firstName
        lastName
        preferredName
        birthDate
        status
        lastVisit
      }
      total
      page
    }
  }
`)

export const CREATE_PAPERWORK_MUTATION = graphql(`
  mutation CreatePaperwork($input: CreatePaperworkInput!) {
    createPaperwork(input: $input) {
      id
      patientId
      status
      expiresDate
      link
    }
  }
`)
